import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { m: "4" }
const _hoisted_2 = {
  key: 1,
  class: "text-container"
}

export interface SortChangeEvent {
  column: object
  prop: string
  order: string
}

export interface TableAttr {
  columns: utils.TableColumnInfo[]
}

export interface EditDlgData {
  key: string // 数据库字段
  label: string // 显示名称
  tag: string // html标签
  disabled: boolean // 是否允许编辑
  dataValue: object // 当前值
  filedType: string, // 字段类型
}
export interface EditDlg {
  action: string // 窗口对应的动作
  title: string // 窗口标题
  editOkBtnName: string // 确定按钮名称
  dialogWidth: string // 窗口宽度
  formLabelWidth: string // 每一行的标签宽度
  url: string // 服务器请求的api地址
  itemList: EditDlgData[] // 当前值
}
// 类型定义结束

// 列编辑窗口是否显示
export interface CustomEventData {
  id: number // 数据在表记录中对应的id
  __targetUrl: string // 按钮绑定的服务地址
  __tableName: string // 是否绑定数据窗口
  __targetSourceId: string // 是否显示确认窗口
}

// 自定义事件

import { ref, defineComponent, defineProps, onMounted, watch } from 'vue'
import * as utils from '../utils'
import TableDataDlg from './TableDataDlg.vue'
import EditColumnTableColDlg from './EditColumnTableColDlg.vue'
import DropDownSelector from './DropDownSelector.vue'
import CascaderSelector from './CascaderSelector.vue'
import DatePicker from './DatePicker.vue'
import ImageItem from './ImageItem.vue'
import LinkItem from './LinkItem.vue'
import SwitchItem from './SwitchItem.vue'
import UploadSingleFileKit from './UploadSingleFileKit.vue'
import store from '../store'

import { ElMessageBox } from 'element-plus'
import { apiPgSelectPath, apiPgInsertPath, apiPgDeletePath, apiPgUpdatePath } from '../config'

// 解决vs中的语法错误提示
const __default__ = defineComponent({
  name: 'QueryTable',
  components: {
    EditColumnTableColDlg,
    TableDataDlg,
    DropDownSelector,
    CascaderSelector,
    ImageItem,
    DatePicker,
    UploadSingleFileKit,
    LinkItem,
    SwitchItem
  }
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  // 列
  tableAttr: {
    type: Object as () => TableAttr,
    require: true
  },
  // 获取数据的url
  fetchDataurl: {
    type: String,
    require: true
  },
  // 绑定的表
  tableName: {
    type: String,
    require: true
  },
  // 操作的目标数据源
  targetSourceId: {
    type: String,
    require: true
  },
  // 是否显示数据
  isShowData: {
    type: Boolean,
    require: true,
    default: true
  },
  // 是否本地化数据
  isI18n: {
    type: Boolean,
    require: true,
    default: true
  },
  // 每页数量的可选list
  pageSizeList: {
    type: Array as () => number[],
    default: () => [10, 20, 30, 40, 100]
  },
  // 当前设置的每页数量
  pageSize: {
    type: Number,
    default: 10
  },
  // 是否是页面编辑模式
  isEditPageMode: {
    type: Boolean,
    required: false,
    default: false
  },
  // 是否显示列编辑窗口
  isShowEditColWin: {
    type: Boolean,
    required: false,
    default: false
  },
  // 是否允许添加数据
  isAddData: {
    type: Boolean,
    required: false,
    default: false
  },
  // 是否允许下载数据
  isDownloadData: {
    type: Boolean,
    required: false,
    default: false
  },
  // 添加数据窗口的title
  addDlgTitle: {
    type: String,
    required: false,
    default: ''
  },
  // 编辑窗口的title
  editDlgTitle: {
    type: String,
    required: false,
    default: ''
  },
  // 编辑窗口的 确定 按钮名称
  editOkBtnName: {
    type: String,
    required: false,
    default: ''
  },
  // 编辑|添加窗口的宽度
  dialogWidth: {
    type: String,
    required: false,
    default: '800'
  },
  // 编辑|添加窗口的标签宽度
  formLabelWidth: {
    type: String,
    required: false,
    default: '140'
  },
  // 编辑窗口保存数据的url
  saveEditDataUrl: {
    type: String,
    required: false,
    default: ''
  },
  // 添加窗口保存数据的url
  saveNewDataUrl: {
    type: String,
    required: false,
    default: ''
  },
  // 删除数据的url
  deleteDataUrl: {
    type: String,
    required: false,
    default: ''
  },
  deleteDataConfirm: {
    type: Boolean,
    required: false,
    default: true
  },
  itemEvents: {
    type: Object as () => utils.TableItemEvents,
    require: true
  }
},
  setup(__props) {

const props = __props

// 总数据数（行数）
const refTotal = ref(0)

// 表格数据
const refTableData = ref([])

// 排序的列
const refProp = ref('')
// 排序方式
const refSortOrder = ref('')

// 每页数量
const refPageSize = ref(props.pageSize)
// 当前页
const refCurrentPage = ref(1)

// 查询条件
const refQueryParam = ref({} as {[key: string]: string})

// 锁定的值
const refLocalValue = ref({} as {[key: string]: string})

// 表的排序事件
const refShowEditColDlg = ref(false)
// 正在编辑的列
const refEditingColumn = ref({} as utils.TableColumnInfo)

// 当前列id
let columnId = 0

// 排序
const sortChange = (e: SortChangeEvent) => {
  refProp.value = e.prop
  refSortOrder.value = e.order === 'descending' ? 'desc' : 'asc'
  queryData()
}

// 改变每页数量
const handleSizeChange = (val: number) => {
  refPageSize.value = val
  queryData()
}

// 翻页
const handleCurrentChange = (val: number) => {
  refCurrentPage.value = val
  queryData()
}

// 通过改变这个值，从而重置 TableDataDlg 的显示状态
const dialogIndex = ref(0)

const rowData = ref<EditDlg>({} as EditDlg)
const refIsShowDlg = ref(false)

const isShowBtn = (event: utils.TableItemEvent, row: object) => {
  // console.info('event', event)
  // console.info('event.isNewEvent', event.isNewEvent)
  if (event.isNewEvent) {
    return false
  }
  // console.info('event.fieldName', event.fieldName)
  // console.info('event.fieldValue', event.fieldValue)
  if (utils.isEmptyString(event.fieldName) || utils.isEmptyString(event.fieldValue)) {
    return true
  }
  // console.info('String(row[event.fieldName])', String(row[event.fieldName]))
  // console.info('String(event.fieldValue)', String(event.fieldValue))
  if (String(row[event.fieldName]) === String(event.fieldValue)) {
    return true
  }
  // console.info('return false')
  return false
}
// 编辑按钮
const handleEdit = (index: number, row: object, event:utils.TableItemEvent) => {
  // eslint-disable-next-line
  const columns = props.tableAttr!.columns
  const itemList = [] as EditDlgData[]
  for (let i = 0; i < columns.length; i++) {
    if (columns[i].isNewCol) {
      continue
    }
    if (!columns[i].isShowInEditDlg) {
      continue
    }
    let key = columns[i].prop
    if (key.endsWith('__')) {
      // 取到原始的数据的值， 而不是转换后的值
      key = key.substring(0, key.length - 2)
    }
    const value = (row as {[key: string]: object})[key]
    const obj = utils.deepCopy(columns[i])
    obj.key = key
    obj.tag = utils.isEmptyString(columns[i].tagInEditDlg) ? 'el-input' : columns[i].tagInEditDlg
    obj.disabled = columns[i].disabledInEditDlg
    obj.dataValue = value
    itemList.push(obj)
  }
  let url = props.saveEditDataUrl
  if (!utils.isNullValue(event)) {
    // 自定事件
    url = event.targetUrl
  } else {
    if (utils.isEmptyString(url)) {
      // 未设置数据的保存地址，直接使用请求的地址
      url = getCommonUrl(apiPgUpdatePath)
    }
  }
  url = generateQueryParam(url, 'query_param__')
  let editDlgTitle = '编辑数据'
  if (!utils.isNullValue(event)) {
    editDlgTitle = event.editDlgTitle
  } else if (!utils.isEmptyString(props.editDlgTitle)) {
    editDlgTitle = props.editDlgTitle
  }
  rowData.value.action = 'editData'
  rowData.value.title = editDlgTitle
  rowData.value.editOkBtnName = utils.isNullValue(event) ? props.editOkBtnName : event.editOkBtnName
  rowData.value.dialogWidth = props.dialogWidth
  rowData.value.formLabelWidth = props.formLabelWidth
  rowData.value.url = url
  rowData.value.itemList = itemList
  refIsShowDlg.value = true
}

const addData = () => {
  // eslint-disable-next-line
  const columns = props.tableAttr!.columns
  const itemList = []
  for (let i = 0; i < columns.length; i++) {
    if (columns[i].isNewCol) {
      continue
    }
    if (!columns[i].isShowInAddDlg) {
      continue
    }
    const obj = utils.deepCopy(columns[i])
    let key = columns[i].prop
    if (key.endsWith('__')) {
      // 取到原始的数据的值， 而不是转换后的值
      key = key.substring(0, key.length - 2)
    }
    obj.key = key
    obj.tag = utils.isEmptyString(columns[i].tagInEditDlg) ? 'el-input' : columns[i].tagInEditDlg
    obj.disabled = false
    itemList.push(obj)
  }
  let url = props.saveNewDataUrl
  if (utils.isEmptyString(url)) {
    url = getCommonUrl(apiPgInsertPath)
  }
  rowData.value.action = 'addData'
  rowData.value.title = utils.isEmptyString(props.addDlgTitle) ? '添加数据' : props.addDlgTitle
  rowData.value.dialogWidth = props.dialogWidth
  rowData.value.formLabelWidth = props.formLabelWidth
  rowData.value.url = url
  rowData.value.itemList = itemList as EditDlgData[]
  refIsShowDlg.value = true
}

function onOk (dialogProps: object, data: object, response: object) {
  refIsShowDlg.value = false
  if ((response as {[success: string]: boolean}).success) {
    queryData()
  }
}
function onCancel (dialogProps: object) {
  refIsShowDlg.value = false
  console.log('onCancel')
}

// 删除按钮
const handleDelete = (index: number, row: object) => {
  let url = props.deleteDataUrl
  if (utils.isEmptyString(url)) {
    url = getCommonUrl(apiPgDeletePath)
  }

  function deleteData (data:object) {
    // eslint-disable-next-line
    utils.apiPostData(url, data)
      .then(data => {
        console.log('deleteData data=', data)
        utils.showRequestResult(data, '删除', '删除失败', '删除结果')
        if ((data as {[success: string]: boolean}).success) {
          queryData()
        }
      })
  }
  if (!props.deleteDataConfirm) {
    deleteData(row)
    return
  }
  ElMessageBox.confirm(
    utils.getI18n('你确认要删除数据吗?'),
    utils.getI18n('注意'),
    {
      confirmButtonText: utils.getI18n('确定'),
      cancelButtonText: utils.getI18n('取消'),
      type: 'warning'
    }
  )
    .then(() => {
      deleteData(row)
    })
    .catch(() => {
      console.log('取消')
    })
}

// 这个类应该没有用了
const customItemEvent = (index: number, row: object, event:utils.TableItemEvent) => {
  if (event.isShowEditDlg) {
    // 弹出数据编辑窗口
    handleEdit(index, row, event)
    return
  }
  console.log('customItemEvent', event.targetUrl)
  let url = event.targetUrl

  let connector = utils.getConnector(url)
  for (const key in refLocalValue.value) {
    const value = refLocalValue.value[key]
    const nkey = utils.convertPropName(key)
    url += `${connector}${nkey}=${value}`
    connector = '&'
  }

  function customEventRequest (data:object) {
    utils.apiPostData(url, data)
      .then(data => {
        console.log('customItemEvent data=', data)
        const result = utils.showRequestResult(data, '请求成功', '')
        if (result.success) {
          queryData()
        }
      })
  }
  const data = { ...row }
  // eslint-disable-next-line
  data.__tableName = props.tableName!
  // eslint-disable-next-line
  data.__targetSourceId = props.targetSourceId!
  data.__targetUrl = event.targetUrl

  // 无确认窗口
  if (!event.isConfirm) {
    customEventRequest(data)
    return
  }

  // 确认窗口
  ElMessageBox.confirm(
    `${utils.getI18n('你确认要执行')}[${utils.getI18n(event.label)}]?`,
    utils.getI18n('注意'),
    {
      confirmButtonText: utils.getI18n('确定'),
      cancelButtonText: utils.getI18n('取消'),
      type: 'warning'
    }
  )
    .then(() => {
      customEventRequest(data)
    })
    .catch(() => {
      console.log('取消')
    })
}
const getCommonUrl = (baseUrl: string) => {
  if (props.tableName === undefined || !props.tableName) {
    return ''
  }
  if (props.targetSourceId === undefined || !props.targetSourceId) {
    return ''
  }
  const queryString = `__tableName=${props.tableName}&__targetSourceId=${props.targetSourceId}`
  let connector = '?'
  if (baseUrl.indexOf(connector) > 0) {
    connector = '&'
  }
  const url = `${baseUrl}${connector}${queryString}`
  return url
}

const generateQueryParam = (url:string, preFix:string) => {
  let connector = utils.getConnector(url)
  for (const key in refQueryParam.value) {
    const value = refQueryParam.value[key]
    let param = ''
    if (utils.isNullValue(value)) {
      param = ''
    } else if (Array.isArray(value)) {
      param = JSON.stringify(value)
    } else if (typeof value === 'string') {
      param = value.trim()
    } else {
      param = value.toString()
    }

    const nkey = preFix + utils.convertPropName(key)
    // url += `&${nkey}=${value}`
    url += `${connector}${nkey}=${encodeURIComponent(param)}`
    connector = '&'
  }
  return url
}

// 向服务器请求数据
const queryData = (isExportData:boolean) => {
  let url = ''
  if (props.fetchDataurl === undefined || !props.fetchDataurl) {
    // 没有设置查询的url， 根据表名自动拼接
    url = getCommonUrl(apiPgSelectPath)
    if (utils.isEmptyString(url)) {
      refTableData.value = []
      refTotal.value = 0
      return
    }
  } else {
    url = props.fetchDataurl
  }

  isShowData = props.isShowData
  if (!props.isShowData && props.isEditPageMode) {
    refTableData.value = []
    refTotal.value = 0
    return
  }
  const connector = utils.getConnector(url)
  url = `${url}${connector}pageSize=${refPageSize.value}&currentPage=${refCurrentPage.value}&sortField=${refProp.value}&sortOrder=${refSortOrder.value}`
  url = generateQueryParam(url, '')
  if (isExportData) {
    url += '&__export=true'
    url = utils.quickAddParams(url, store.state.pageAdditionalParam[store.state.currentMenuId])
    window.open(url, '_blank')
    return
  }
  // refTableData.value = []
  // eslint-disable-next-line
  const columnDict = utils.convertCloumnArr2Dict(props.tableAttr!.columns)
  utils.apiFetchData(url)
    .then(data => {
      refTableData.value = data.data
      refTotal.value = data.total
      // i18nTableData()
      utils.transferTableData(props.isI18n, refTableData.value, columnDict)
    })
    .catch(error => console.error(error))
}

// 重置查询区
const reset = () => {
  for (const key in refQueryParam.value) {
    refQueryParam.value[key] = ''
  }
}

const getColumnLength = (): number => {
  if (props.tableAttr !== undefined && props.tableAttr.columns !== undefined) {
    return props.tableAttr.columns.length
  }
  return 0
}

// 取得列名
const getLabel = (prop: string): string => {
  for (let i = 0; i < getColumnLength(); i++) {
    if (props.tableAttr?.columns[i].prop === prop) {
      return props.tableAttr?.columns[i].label
    }
  }
  return ''
}

// 查询区按钮span的值
const getButtonSpan = (): number => {
  let span = 0
  for (let i = 0; i < getColumnLength(); i++) {
    // todo 先这样计算，为以后能后设置每一个 查询条件预留 单独的设置
    if (utils.isTrue(props.tableAttr?.columns[i].isQuery)) {
      span += 8
    }
  }
  span = 24 - (span % 24)
  return span
}

function hasQueryArea (): boolean {
  for (let i = 0; i < getColumnLength(); i++) {
    if (utils.isTrue(props.tableAttr?.columns[i].isQuery)) {
      return true
    }
  }
  return false
}
function hasLocakValueArea (): boolean {
  for (let i = 0; i < getColumnLength(); i++) {
    if (utils.isTrue(props.tableAttr?.columns[i].isLocalvalue)) {
      return true
    }
  }
  return false
}
// 添加新的列
function addNewColumn () {
  // eslint-disable-next-line
  props.tableAttr!.columns.push({
    id: String(columnId++),
    columnType: 'normal',
    filedType: '',
    prop: '',
    label: '',
    width: '120',
    isShow: true,
    isSortable: false,
    isQuery: false,
    queryTag: 'el-input',
    isExpand: false,
    isLocalvalue: false,
    actions: {
      edit: false,
      delete: false
    },
    isNewCol: true,

    isShowInEditDlg: false,
    disabledInEditDlg: false,
    tagInEditDlg: 'el-input',
    isShowInAddDlg: false,

    dateSelectType: 'date'
  })
}
const getQueryBindItem = (col: utils.TableColumnInfo) => {
  // return { srcDataUrl: col.srcDataUrl }
  return col
}
// 编辑列
const editColumn = (column: utils.TableColumnInfo) => {
  refEditingColumn.value = column
  refShowEditColDlg.value = true
}

// 添加列
const addColumn = (index: number) => {
  // eslint-disable-next-line
  props.tableAttr!.columns[index].isNewCol = false
  addNewColumn()
}

// 删除列
const removeColumn = (index: number) => {
  // eslint-disable-next-line
  props.tableAttr!.columns.splice(index, 1)
}

// 上移
const moveUp = (index: number) => {
  if (index === 0) {
    return
  }
  const m = props.tableAttr?.columns[index - 1]
  // eslint-disable-next-line
  props.tableAttr!.columns[index - 1] = props.tableAttr!.columns[index]
  // eslint-disable-next-line
  props.tableAttr!.columns[index] = m!
}

// 下移
const moveDown = (index: number) => {
  const length = getColumnLength()
  if (index === length - 1) {
    return
  }
  const m = props.tableAttr?.columns[index + 1]
  // eslint-disable-next-line
  props.tableAttr!.columns[index + 1] = props.tableAttr!.columns[index]
  // eslint-disable-next-line
  props.tableAttr!.columns[index] = m!
}

// 重构列数据，添加缺失的字段
function restructColumns () {
  if (!props.isEditPageMode) {
    return
  }
  // eslint-disable-next-line
  let columns = props.tableAttr!.columns
  columns = columns.filter((value: utils.TableColumnInfo) => !utils.isTrue(value.isNewCol))
  // eslint-disable-next-line
  props.tableAttr!.columns = columns

  // 找到最大的id
  let maxColumnId = ''
  for (let i = 0; i < getColumnLength(); i++) {
    if (utils.isNullValue(props.tableAttr?.columns[i].id)) {
      // eslint-disable-next-line
      if (maxColumnId < props.tableAttr!.columns[i].id) {
        // eslint-disable-next-line
        maxColumnId = props.tableAttr!.columns[i].id
      }
    }
  }
  if (maxColumnId !== '') {
    columnId = Number(maxColumnId)
  }

  // 修正数据
  for (let i = 0; i < getColumnLength(); i++) {
    if (utils.isNullValue(props.tableAttr?.columns[i].id)) {
      // eslint-disable-next-line
      props.tableAttr!.columns[i].id = String(columnId++)
    }
    if (utils.isNullValue(props.tableAttr?.columns[i].actions)) {
      // eslint-disable-next-line
      props.tableAttr!.columns[i].actions = { edit: false, delete: false }
    }
    if (utils.isNullValue(props.tableAttr?.columns[i].isShow)) {
      // eslint-disable-next-line
      props.tableAttr!.columns[i].isShow = true
    }
    if (utils.isNullValue(props.tableAttr?.columns[i].queryTag)) {
      // eslint-disable-next-line
      props.tableAttr!.columns[i].queryTag = 'el-input'
    }
    // eslint-disable-next-line
    if (!utils.isEmptyString(props.tableAttr!.columns[i].columnType)) {
      if (props.tableAttr?.columns[i].columnType === 'expand') {
        continue
      } else if (props.tableAttr?.columns[i].columnType === 'action') {
        if (props.tableAttr?.columns[i].actions.edit === undefined || props.tableAttr?.columns[i].actions.edit === null) {
          // eslint-disable-next-line
          props.tableAttr!.columns[i].actions.edit = false
        }
        if (props.tableAttr?.columns[i].actions.delete === undefined || props.tableAttr?.columns[i].actions.delete === null) {
          // eslint-disable-next-line
          props.tableAttr!.columns[i].actions.delete = false
        }
      }
    } else {
      // eslint-disable-next-line
      props.tableAttr!.columns[i].columnType = 'normal'     
      if (utils.isNullValue(props.tableAttr?.columns[i].isQuery)) {
        // eslint-disable-next-line
        props.tableAttr!.columns[i].isQuery = false
      }
      if (utils.isNullValue(props.tableAttr?.columns[i].isExpand)) {
        // eslint-disable-next-line
        props.tableAttr!.columns[i].isExpand = false
      }
      if (utils.isNullValue(props.tableAttr?.columns[i].isLocalvalue)) {
        // eslint-disable-next-line
        props.tableAttr!.columns[i].isLocalvalue = false
      }
    }
  }
  addNewColumn()
}

let dataUrl = ''
let isShowData = true
watch(props, (newValue, oldValue) => {
  if (dataUrl === newValue.fetchDataurl && isShowData === props.isShowData) {
    return
  }
  dataUrl = props.fetchDataurl
  restructColumns()
  queryData()
})

// 重构列数据，添加缺失的字段
function correctColumns () {
  // eslint-disable-next-line
  for (let i = 0; i < getColumnLength(); i++) {
    if (utils.isEmptyString(props.tableAttr?.columns[i].tagInEditDlg)) {
      props.tableAttr!.columns[i].tagInEditDlg = 'el-input'
    }
  }
}
// mounted时
onMounted(async () => {
  correctColumns()
  restructColumns()
  refPageSize.value = props.pageSizeList[0]
  try {
    queryData()
  } catch (error) {
    console.error(error)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_Top = _resolveComponent("Top")!
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, {
      gutter: 12,
      class: "demo-radius",
      align: "middle"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tableAttr.columns, (col2) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: col2.prop
          }, [
            ((utils.isTrue(col2.isQuery)))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_el_col, {
                    span: 4,
                    align: "right",
                    style: {"margin-bottom":"10px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_text, { class: "mx-1" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(utils.getI18n(getLabel(col2.prop))) + ":", 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_col, {
                    span: 4,
                    style: {"margin-bottom":"10px"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(col2.tagInEditDlg), _mergeProps({
                        name: col2.prop
                      }, getQueryBindItem(col2), {
                        isShowQueryZone: true,
                        class: "param",
                        modelValue: refQueryParam.value[col2.prop],
                        "onUpdate:modelValue": ($event: any) => ((refQueryParam.value[col2.prop]) = $event)
                      }), null, 16, ["name", "modelValue", "onUpdate:modelValue"]))
                    ]),
                    _: 2
                  }, 1024)
                ], 64))
              : _createCommentVNode("", true)
          ], 64))
        }), 128)),
        _createVNode(_component_el_col, {
          span: getButtonSpan(),
          align: "right"
        }, {
          default: _withCtx(() => [
            (hasQueryArea())
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (queryData()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(utils.getI18n('查询',true)), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!hasQueryArea())
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  type: "primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (queryData()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(utils.getI18n('刷新',true)), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (hasQueryArea())
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 2,
                  type: "primary",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (reset()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(utils.getI18n('重置')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (__props.isAddData)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 3,
                  type: "primary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (addData()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(utils.getI18n('添加')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (__props.isDownloadData)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 4,
                  type: "primary",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (queryData(true)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(utils.getI18n('下载')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["span"])
      ]),
      _: 1
    }),
    (hasLocakValueArea())
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_el_divider),
          _createVNode(_component_el_row, {
            gutter: 12,
            class: "demo-radius",
            align: "middle"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tableAttr.columns, (col2) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: col2.prop
                }, [
                  ((utils.isTrue(col2.isLocalvalue)))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_el_col, {
                          span: 4,
                          align: "right",
                          style: {"margin-bottom":"10px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_text, { class: "mx-1" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(utils.getI18n(getLabel(col2.prop))) + ":", 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_col, {
                          span: 4,
                          style: {"margin-bottom":"10px"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(col2.tagInEditDlg), _mergeProps({
                              name: col2.prop
                            }, getQueryBindItem(col2), {
                              class: "local-value",
                              modelValue: refLocalValue.value[col2.prop],
                              "onUpdate:modelValue": ($event: any) => ((refLocalValue.value[col2.prop]) = $event)
                            }), null, 16, ["name", "modelValue", "onUpdate:modelValue"]))
                          ]),
                          _: 2
                        }, 1024)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]),
            _: 1
          })
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_el_table, {
      data: refTableData.value,
      border: "",
      style: {"width":"100%"},
      onSortChange: sortChange,
      align: "left"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tableAttr.columns, (col) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: col.prop
          }, [
            (col.isNewCol===true)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
              : (col.isShow===true && col.columnType=='expand')
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 1,
                    type: "expand"
                  }, {
                    default: _withCtx((props) => [
                      _createElementVNode("div", _hoisted_1, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tableAttr.columns, (col2) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: col2 }, [
                            (!col2.isNewCol && col2.isExpand==true)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (col2.columnType=='link'  || col2.prop.endsWith('__link'))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(utils.getI18n(col2.label)) + ": ", 1),
                                        (_openBlock(), _createBlock(LinkItem, {
                                          key: `${col2.prop}-${props.row.id}`,
                                          dataValue: props.row[col2.prop]
                                        }, null, 8, ["dataValue"]))
                                      ], 64))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(utils.getI18n(col2.label)) + ": " + _toDisplayString(utils.getI18n(utils.convertUTC2LocalTime(props.row[col2.prop]))), 1))
                                ], 64))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }))
                : (col.isShow===true && col.columnType=='action')
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 2,
                      label: utils.getI18n(col.label),
                      width: col.width
                    }, {
                      default: _withCtx((scope) => [
                        (!utils.isNullValue(col.actions))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (utils.isEmptyString(col.actions.editBtnName))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (col.actions.edit===true)
                                      ? (_openBlock(), _createBlock(_component_el_button, {
                                          key: 0,
                                          size: "small",
                                          onClick: ($event: any) => (handleEdit(scope.$index, scope.row)),
                                          style: {"margin-top":"8px","margin-left":"5px"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_icon, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_Edit)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (_openBlock(), _createBlock(_component_el_button, {
                                    key: 1,
                                    type: "primary",
                                    onClick: ($event: any) => (handleEdit(scope.$index, scope.row)),
                                    style: {"margin-top":"8px","margin-left":"5px"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(utils.getI18n(col.actions.editBtnName)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])),
                              (col.actions.delete===true)
                                ? (_openBlock(), _createBlock(_component_el_button, {
                                    key: 2,
                                    size: "small",
                                    type: "danger",
                                    onClick: ($event: any) => (handleDelete(scope.$index, scope.row)),
                                    style: {"margin-top":"8px","margin-left":"5px"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Delete)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.itemEvents.eventList, (event, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                            (isShowBtn(event, scope.row))
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  size: "small",
                                  onClick: ($event: any) => (customItemEvent(scope.$index, scope.row, event)),
                                  style: {"margin-top":"8px","margin-left":"5px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(utils.getI18n(event.label)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["label", "width"]))
                  : (col.isShow===true && (col.columnType=='link'  || col.prop.endsWith('__link')))
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 3,
                        label: utils.getI18n(col.label),
                        width: col.width
                      }, {
                        default: _withCtx((scope) => [
                          (_openBlock(), _createBlock(LinkItem, {
                            key: `${col.prop}-${scope.row.id}`,
                            dataValue: scope.row[col.prop]
                          }, null, 8, ["dataValue"]))
                        ]),
                        _: 2
                      }, 1032, ["label", "width"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                        (col.isShow===true)
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 0,
                              prop: col.prop,
                              label: utils.getI18n(col.label),
                              width: col.width,
                              sortable: col.isSortable
                            }, null, 8, ["prop", "label", "width", "sortable"]))
                          : _createCommentVNode("", true)
                      ], 64))
          ], 64))
        }), 128))
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_pagination, {
      "current-page": refCurrentPage.value,
      "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => ((refCurrentPage).value = $event)),
      "page-size": refPageSize.value,
      "onUpdate:pageSize": _cache[6] || (_cache[6] = ($event: any) => ((refPageSize).value = $event)),
      "page-sizes": __props.pageSizeList,
      layout: "total, sizes, prev, pager, next, jumper",
      total: refTotal.value,
      onSizeChange: handleSizeChange,
      onCurrentChange: handleCurrentChange,
      style: {"margin-top":"10px","justify-content":"center"}
    }, null, 8, ["current-page", "page-size", "page-sizes", "total"]),
    (refIsShowDlg.value)
      ? (_openBlock(), _createBlock(TableDataDlg, {
          key: 1,
          data: rowData.value,
          dialogIndex: dialogIndex.value,
          onOnOk: onOk,
          onOnCancel: onCancel,
          "destroy-on-close": true
        }, null, 8, ["data", "dialogIndex"]))
      : _createCommentVNode("", true),
    (__props.isEditPageMode)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (__props.isShowEditColWin)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_el_table, {
                  data: __props.tableAttr.columns,
                  "row-key": "id",
                  border: "",
                  style: {"width":"100%"},
                  align: "left"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      prop: "prop",
                      label: "字段名",
                      width: "150"
                    }, {
                      default: _withCtx((data) => [
                        _createVNode(_component_el_input, {
                          modelValue: data.row.prop,
                          "onUpdate:modelValue": ($event: any) => ((data.row.prop) = $event),
                          disabled: data.row.columnType!='normal' && data.row.columnType!='link',
                          placeholder: '数据字段'
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "lable",
                      label: "列名",
                      width: "120"
                    }, {
                      default: _withCtx((data) => [
                        _createVNode(_component_el_input, {
                          modelValue: data.row.label,
                          "onUpdate:modelValue": ($event: any) => ((data.row.label) = $event),
                          placeholder: '列名'
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "width",
                      label: "列宽度",
                      width: "120"
                    }, {
                      default: _withCtx((data) => [
                        _createVNode(_component_el_input, {
                          modelValue: data.row.width,
                          "onUpdate:modelValue": ($event: any) => ((data.row.width) = $event),
                          placeholder: '宽度'
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "isShow",
                      label: "显示",
                      width: "75"
                    }, {
                      default: _withCtx((data) => [
                        _createVNode(_component_el_switch, {
                          modelValue: data.row.isShow,
                          "onUpdate:modelValue": ($event: any) => ((data.row.isShow) = $event),
                          style: {"--el-switch-on-color":"#2196F3","--el-switch-off-color":"#B0B0B0"}
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "isSortable",
                      label: "排序",
                      width: "75"
                    }, {
                      default: _withCtx((data) => [
                        (data.row.columnType==='normal')
                          ? (_openBlock(), _createBlock(_component_el_switch, {
                              key: 0,
                              modelValue: data.row.isSortable,
                              "onUpdate:modelValue": ($event: any) => ((data.row.isSortable) = $event),
                              style: {"--el-switch-on-color":"#2196F3","--el-switch-off-color":"#B0B0B0"}
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "isQuery",
                      label: "查询",
                      width: "75"
                    }, {
                      default: _withCtx((data) => [
                        (data.row.columnType==='normal')
                          ? (_openBlock(), _createBlock(_component_el_switch, {
                              key: 0,
                              modelValue: data.row.isQuery,
                              "onUpdate:modelValue": ($event: any) => ((data.row.isQuery) = $event),
                              style: {"--el-switch-on-color":"#2196F3","--el-switch-off-color":"#B0B0B0"}
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "操作",
                      width: "140"
                    }, {
                      default: _withCtx((data) => [
                        (data.row.isNewCol)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              type: "success",
                              onClick: ($event: any) => (addColumn(data.$index))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Plus)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                onClick: ($event: any) => (editColumn(data.row))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Edit)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_el_button, {
                                type: "danger",
                                onClick: ($event: any) => (removeColumn(data.$index))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Delete)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ], 64))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "位置",
                      width: "0"
                    }, {
                      default: _withCtx((data) => [
                        _createVNode(_component_el_row, {
                          gutter: 12,
                          class: "demo-radius",
                          align: "middle"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  disabled: data.$index===0,
                                  onClick: ($event: any) => (moveUp(data.$index))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Top)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["disabled", "onClick"])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  disabled: data.$index===getColumnLength()-1,
                                  onClick: ($event: any) => (moveDown(data.$index))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Bottom)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["disabled", "onClick"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"]),
                (refShowEditColDlg.value)
                  ? (_openBlock(), _createBlock(EditColumnTableColDlg, {
                      key: 0,
                      modelValue: refShowEditColDlg.value,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((refShowEditColDlg).value = $event)),
                      column: refEditingColumn.value
                    }, null, 8, ["modelValue", "column"]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_component_el_row)
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

})